import BoxMainHeader from "./BoxMainHeader";
import styled from "styled-components";
import Table from "../../components/Table/";

const Dependents = ({ boxMainHeader, columns, data }) => {
  return (
    <>
      <BoxMainHeader header={boxMainHeader} />
      <TableWrapper>
        <Table columns={columns} data={data} fixedLayout={false} />
      </TableWrapper>
    </>
  );
};

const TableWrapper = styled.div`
  @media (max-width: 769px) {
    display: none;
  }
  > table > thead > tr > th > div {
    padding-bottom: 0rem;
    font-size: 0.875rem;
  }

  > table > tbody > tr > td {
    padding: 0.25rem 0rem 1.313rem;
  }

  > table > tbody > tr > td > div {
    font-weight: 600;
    font-size: 1.125rem;
  }
`;

export default Dependents;
